import type { InjectionKey, Ref } from 'vue'
import type { MaybeComputedElementRef } from '@vueuse/core'
import { provide, ref } from 'vue'
import { useResizeObserver } from '@vueuse/core'

type OverlayHeightKey = InjectionKey<Ref<number>>

export const id = 'audio-embed-outlet'
export const key: OverlayHeightKey = Symbol('overlay-outlet-height')

export function useOverlayOutlet(target?: MaybeComputedElementRef<HTMLElement | null>) {
  const height = ref(0)

  useResizeObserver(target, ([{ borderBoxSize }]) => {
    height.value = borderBoxSize?.[0].blockSize ?? 0
  })

  provide(key, height)

  return {
    id,
    key,
    height,
  }
}
